<div class="route-selection-area">
    <div class="route-selection-add-route"> 
        
        <div class="route-selection-hint" *ngIf="selectedRoutes.length < 1">Click this button to select a route. </div>
        <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#routeSelectionModal">
            <svg class="bi bi-plus" width="1em" height="1em" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M10 5.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H6a.5.5 0 010-1h3.5V6a.5.5 0 01.5-.5z" clip-rule="evenodd"></path>
                <path fill-rule="evenodd" d="M9.5 10a.5.5 0 01.5-.5h4a.5.5 0 010 1h-3.5V14a.5.5 0 01-1 0v-4z" clip-rule="evenodd"></path>
            </svg>
        </button>
    </div>
    <div class="route-selection-container" *ngFor="let route of selectedRoutes">
        <div class="route-selection-remove" (click)="onSelect(route)" style="cursor: pointer;">
                <svg class="bi bi-x-square" width="1.5em" height="1.5em" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M16 3H4a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1V4a1 1 0 00-1-1zM4 2a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V4a2 2 0 00-2-2H4z" clip-rule="evenodd"></path>
                    <path fill-rule="evenodd" d="M9.293 10L6.646 7.354l.708-.708L10 9.293l2.646-2.647.708.708L10.707 10l2.647 2.646-.708.708L10 10.707l-2.646 2.647-.708-.707L9.293 10z" clip-rule="evenodd"></path>
                </svg>
        </div>
        <div class="route-selection-route">
            {{route.name}}
        </div>
        <div class="route-selection-bottom-container">
            <div class="route-selection-bottom-contents">
                <div class="route-selection-divider">
                    ------------
                </div>
                <div class="route-selection-status" (click)="onDetail(route)" style="cursor: pointer;">
                    <span [ngClass]="{'icon-inactive': route.isalert === false}">
                      <img class="status-icons" src="../../../assets/images/route-status/alert.png" *ngIf="route.issuspended == false">
                      <img class="status-icons" src="../../../assets/images/route-status/suspended.png" *ngIf="route.issuspended == true">
                    </span>
                    <span [ngClass]="{'icon-inactive': route.isadvisory === false}">
                        <img class="status-icons" src="../../../assets/images/route-status/advisory.png">
                    </span>
                    <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == true">
                        <img class="status-icons" src="../../../assets/images/route-status/weather-icon.png">
                    </span>
                    <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == false">
                        <img class="status-icons" src="../../../assets/images/route-status/detour.png">
                    </span>
                    <span [ngClass]="{'icon-inactive': route.iselevator === false}">
                        <img class="status-icons" src="../../../assets/images/route-status/elevator.gif">
                    </span>
                </div>
            </div>
        </div>
    </div>

</div>

<!-- Route Selection Modal -->
<div class="modal fade" id="routeSelectionModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-full" role="document">
      <div class="modal-content">
        <div class="modal-body">
            <div class="row d-flex p-2 text-center">
                <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                        <a class="nav-item nav-link active" id="nav-bus-tab" data-toggle="tab" href="#nav-bus" role="tab" aria-controls="nav-bus" aria-selected="true">
                            <div class="status-icons">
                                <img class="status-icons" src="../../../assets/images/modes/bus/bus-status.png">

                            </div>
                            <span class="badge">
                                Bus
                            </span>
                        </a>
                        <a class="nav-item nav-link" id="nav-rail-tab" data-toggle="tab" href="#nav-rail" role="tab" aria-controls="nav-rail" aria-selected="false">
                            <div class="status-icons">
                                <img class="status-icons" src="../../../assets/images/modes/rail/rail-status.png">
                            </div>
                            <span class="badge">
                                Rail
                            </span>
                        </a>
                        <a class="nav-item nav-link" id="nav-others-tab" data-toggle="tab" href="#nav-others" role="tab" aria-controls="nav-others" aria-selected="false">
                            <div class="status-icons">
                                <img class="status-icons" src="../../../assets/images/modes/mfl/mfl-status.png">
                            </div>
                            <span class="badge">
                                Other
                            </span>
                        </a>
                        <a class="nav-item nav-link" id="nav-trolley-tab" data-toggle="tab" href="#nav-trolley" role="tab" aria-controls="nav-trolley" aria-selected="false">
                            <div class="status-icons">
                                <img class="status-icons" src="../../../assets/images/modes/trolley/trolley-status.png">
                            </div>
                            <span class="badge">
                                Trolley
                            </span>
                        </a>
                    </div>
                </nav>
            </div>
            <div class="tab-content" id="nav-tabContent">
                <div class="tab-pane fade show active" id="nav-bus" role="tabpanel" aria-labelledby="nav-bus-tab">
                    <div>
                        <div class="row mx-auto" *ngFor="let routes of statuses['bus']; index as i">
                            <div class="col-sm-12 border-bottom route-selectable" *ngFor="let route of routes" (click)="onSelect(route)" style="cursor: pointer;">
                                <div><strong> {{ route.name }} </strong> <span *ngIf="selectedRoutes" [ngClass]="{'selected-icon-inactive': selectedRoutes.indexOf(route) < 0 }">&nbsp;&nbsp;&nbsp;&nbsp;<span class="badge badge-success">&#10003;</span></span> </div>
                                <div class="">{{ route.description }}</div>
                                <div class="route-selection-status">
                                    <span [ngClass]="{'icon-inactive': route.isalert === false}">
                                      <img class="status-icons" src="../../../assets/images/route-status/alert.png" *ngIf="route.issuspended == false">
                                      <img class="status-icons" src="../../../assets/images/route-status/suspended.png" *ngIf="route.issuspended == true">
                                    </span>
                                    <span [ngClass]="{'icon-inactive': route.isadvisory === false}">
                                        <img class="status-icons" src="../../../assets/images/route-status/advisory.png">
                                    </span>
                                    <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == true">
                                        <img class="status-icons" src="../../../assets/images/route-status/weather-icon.png">
                                    </span>
                                    <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == false">
                                        <img class="status-icons" src="../../../assets/images/route-status/detour.png">
                                    </span>
                                    <span [ngClass]="{'icon-inactive': route.iselevator === false}">
                                        <img class="status-icons" src="../../../assets/images/route-status/elevator.gif">
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade" id="nav-rail" role="tabpanel" aria-labelledby="nav-rail-tab">
                    <div>
                        <div class="row mx-auto" *ngFor="let routes of statuses['rail']; index as i">
                            <div class="col-sm-12 border-bottom route-selectable" *ngFor="let route of routes" (click)="onSelect(route)" style="cursor: pointer;">
                                <strong> {{ route.name }} </strong> <span *ngIf="selectedRoutes" [ngClass]="{'selected-icon-inactive': selectedRoutes.indexOf(route) < 0 }">&nbsp;&nbsp;&nbsp;&nbsp;<span class="badge badge-success">&#10003;</span></span>
                                <div class="">{{ route.description }}</div>
                                <div class="route-selection-status">
                                    <span [ngClass]="{'icon-inactive': route.isalert === false}">
                                      <img class="status-icons" src="../../../assets/images/route-status/alert.png" *ngIf="route.issuspended == false">
                                      <img class="status-icons" src="../../../assets/images/route-status/suspended.png" *ngIf="route.issuspended == true">
                                    </span>
                                    <span [ngClass]="{'icon-inactive': route.isadvisory === false}">
                                        <img class="status-icons" src="../../../assets/images/route-status/advisory.png">
                                    </span>
                                    <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == true">
                                        <img class="status-icons" src="../../../assets/images/route-status/weather-icon.png">
                                    </span>
                                    <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == false">
                                        <img class="status-icons" src="../../../assets/images/route-status/detour.png">
                                    </span>
                                    <span [ngClass]="{'icon-inactive': route.iselevator === false}">
                                        <img class="status-icons" src="../../../assets/images/route-status/elevator.gif">
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade" id="nav-others" role="tabpanel" aria-labelledby="nav-others-tab">
                    <div>
                        <div class="row mx-auto" *ngFor="let routes of statuses['others']; index as i">
                            <div class="col-sm-12 border-bottom route-selectable" *ngFor="let route of routes" (click)="onSelect(route)" style="cursor: pointer;">
                                <strong> {{ route.name }} </strong> <span *ngIf="selectedRoutes" [ngClass]="{'selected-icon-inactive': selectedRoutes.indexOf(route) < 0 }">&nbsp;&nbsp;&nbsp;&nbsp;<span class="badge badge-success">&#10003;</span></span>
                                <div class="">{{ route.description }}</div>
                                <div class="">
                                    <span [ngClass]="{'icon-inactive': route.isalert === false}">
                                      <img class="status-icons" src="../../../assets/images/route-status/alert.png" *ngIf="route.issuspended == false">
                                      <img class="status-icons" src="../../../assets/images/route-status/suspended.png" *ngIf="route.issuspended == true">
                                    </span>
                                    <span [ngClass]="{'icon-inactive': route.isadvisory === false}">
                                        <img class="status-icons" src="../../../assets/images/route-status/advisory.png">
                                    </span>
                                    <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == true">
                                        <img class="status-icons" src="../../../assets/images/route-status/weather-icon.png">
                                    </span>
                                    <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == false">
                                        <img class="status-icons" src="../../../assets/images/route-status/detour.png">
                                    </span>
                                    <span [ngClass]="{'icon-inactive': route.iselevator === false}">
                                        <img class="status-icons" src="../../../assets/images/route-status/elevator.gif">
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade" id="nav-trolley" role="tabpanel" aria-labelledby="nav-trolley-tab">
                    <div class="row mx-auto" *ngFor="let routes of statuses['trolley']; index as i">
                        <div class="col-sm-12 border-bottom route-selectable" *ngFor="let route of routes" (click)="onSelect(route)">
                            <strong> {{ route.name }} </strong> <span *ngIf="selectedRoutes" [ngClass]="{'selected-icon-inactive': selectedRoutes.indexOf(route) < 0 }">&nbsp;&nbsp;&nbsp;&nbsp;<span class="badge badge-success">&#10003;</span></span>
                            <div class="">{{ route.description }}</div>
                            <div class="route-selection-status">
                                <span [ngClass]="{'icon-inactive': route.isalert === false}">
                                  <img class="status-icons" src="../../../assets/images/route-status/alert.png" *ngIf="route.issuspended == false">
                                  <img class="status-icons" src="../../../assets/images/route-status/suspended.png" *ngIf="route.issuspended == true">
                                </span>
                                <span [ngClass]="{'icon-inactive': route.isadvisory === false}">
                                    <img class="status-icons" src="../../../assets/images/route-status/advisory.png">
                                </span>
                                <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == true">
                                    <img class="status-icons" src="../../../assets/images/route-status/weather-icon.png">
                                </span>
                                <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == false">
                                    <img class="status-icons" src="../../../assets/images/route-status/detour.png">
                                </span>
                                <span [ngClass]="{'icon-inactive': route.iselevator === false}">
                                    <img class="status-icons" src="../../../assets/images/route-status/elevator.gif">
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
